import { render } from "./pdf-tabs.vue?vue&type=template&id=183959cf"
import script from "./pdf-tabs.vue?vue&type=script&lang=js"
export * from "./pdf-tabs.vue?vue&type=script&lang=js"

import "./pdf-tabs.vue?vue&type=style&index=0&id=183959cf&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__